export default __webpack_public_path__ + "static/media/TheRecharge_Neoncar00312.6f80b2ec.png";